import {combineEpics} from 'redux-observable';
import {loadConfigEpic} from './configEpic';


export const rootEpic = combineEpics(
  loadConfigEpic
);
